import React from 'react'
import whats from "../../assets/whatsapp.png"
const WhatsAppTop = () => {
    return (
        <div>
            <div>
                <div className="fixed bottom-2 right-2">
                    <a
                        href="https://wa.me/919444161667"
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-500 hover:text-gray-900 dark:hover:text-white"
                    >
                        <img src={whats} alt="whatsapp" className="h-10" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default WhatsAppTop